import Cookies from 'js-cookie';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { doesCustomerExist } from 'common/helpers/customerHelper';
import { customerId } from 'common/helpers/tokenHelper';
import { RECORD_EVENT_REQUEST } from 'redux/analytics/constants';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { get as getClub } from '../clubs/sagas';

import {
  authenticateForFullSteamWallet,
  getClubSignupForSharing,
  createClubSignup,
  processClubSignup,
  processPayStackClubSignup,
  processFullsteamClubSignup,
  createCustomerAndSetupIntent,
  processClubSignupFromPaymentRequest,
  getClubSignup,
  getVirtualCart,
  editVirtualSignUp,
  updateClubSignup,
  updateClubSignupItems
} from './api';
import {
  UPDATE_CLUB_SIGNUP_REQUEST,
  GET_CLUB_SIGNUP_FOR_SHARING_REQUEST,
  EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST,
  CLUB_SIGNUP_REQUEST,
  CLUB_SIGNUP_OBJECT_REQUESTING,
  CLUB_SIGNUP_VIRTUAL_SUCCESS,
  RESET_CLUB_SIGNUP_ISFETCHING,
  PROCESS_CLUB_SIGN_UP_REQUEST,
  CREATE_CLUB_SIGNUP_REQUEST,
  CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST,
  CREATE_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST,
  PROCESS_STRIPE_CLUB_SIGNUP_FROM_PAYMENT_REQUEST,
  GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET,
  CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_REQUESTING,
  CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_SUCCESS,
  PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST,
  PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUESTING,
  PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_SUCCESS,
  CLUB_SIGNUP_SUCCESS,
  GET_VIRTUAL_CART_REQUEST,
  RESET_CLUB_SIGNUP_FULLSTEAM_WALLET_ISFETCHING,
  PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST,
  UPDATE_DYNAMIC_PRICING_CLUB_SIGNUP_PACKAGE_REQUEST
} from './constants';

function* authenticateFullSteamWallet(action) {
  try {
    yield call(removeAPIError);

    yield put({ type: CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_REQUESTING });
    const response = yield call(authenticateForFullSteamWallet);

    yield put({
      type: CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_SUCCESS,
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    delete error.response.data.errors;
    yield put({ type: RESET_CLUB_SIGNUP_FULLSTEAM_WALLET_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* processClubForDigitalWallet(action) {
  try {
    yield call(removeAPIError);

    yield put({ type: PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUESTING });
    const response = yield call(
      processFullsteamClubSignup,
      action.clubSignupId,
      action.payload
    );
    yield put({
      type: PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_SUCCESS,
      payload: response.data
    });

    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubSignupComplete',
      payload: response.data
    });

    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    delete error.response.data.errors;
    if (action.onError) {
      action.onError(error);
    }
    if (error.response && error.response.status === 404) {
      Cookies.remove('clubSignupId');
      yield put({ type: CLUB_SIGNUP_SUCCESS, payload: {} });
    } else {
      yield put({ type: RESET_CLUB_SIGNUP_FULLSTEAM_WALLET_ISFETCHING });
      yield call(addAPIError, error);
    }
  }
}

export function* get() {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    if (!clubSignupId()) {
      yield put({ type: CLUB_SIGNUP_SUCCESS, payload: {} });
    } else {
      const response = yield call(getClubSignup, clubSignupId());
      yield put({ type: CLUB_SIGNUP_SUCCESS, payload: response.data });

      // get the virtual cart after we get the obj
      yield put({ type: GET_VIRTUAL_CART_REQUEST });
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      Cookies.remove('clubSignupId');
      yield put({ type: CLUB_SIGNUP_SUCCESS, payload: {} });
    } else {
      yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
      yield call(addAPIError, error);
    }
  }
}

export function* updateDynamicClubSignupPricing(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      updateClubSignupItems,
      clubSignupId(),
      action.items
    );
    yield put({ type: CLUB_SIGNUP_SUCCESS, payload: response.data });
  } catch (error) {
    if (error.response && error.response.status === 404) {
      Cookies.remove('clubSignupId');
      yield put({ type: CLUB_SIGNUP_SUCCESS, payload: {} });
    } else {
      yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
      yield call(addAPIError, error);
    }
  }
}

function* getForSharing(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      getClubSignupForSharing,
      action.id,
      customerId()
    );
    const clubSignup = response.data;
    Cookies.set('clubSignupId', clubSignup.id, {
      expires: 365,
      secure: process.env.APP_MODE === 'production'
    });
    yield put({ type: CLUB_SIGNUP_SUCCESS, clubSignup });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      Cookies.remove('clubSignupId');
      yield put({ type: CLUB_SIGNUP_SUCCESS, payload: {} });
    } else {
      yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
      yield call(addAPIError, error);
    }
  }
}

function* getVirtualCartSaga(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(getVirtualCart, clubSignupId());
    yield put({ type: CLUB_SIGNUP_VIRTUAL_SUCCESS, payload: response.data });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch {
    // if there is an error getting the virtual cart, we just return an empty object and proceed to the signup regardless of status code
    yield put({ type: CLUB_SIGNUP_VIRTUAL_SUCCESS, payload: {} });
  }
}

function* createBySlug(action) {
  const { slug } = action;
  const club = yield getClub({ slug });
  action.club = { id: club.id };
  yield create(action);
}

function* create(action) {
  const { club } = action;
  const newClubSignup = {
    clubId: club.id,
    connectionInformation: {
      userAgent: navigator.userAgent
    }
  };
  if (!clubSignupId()) {
    if (doesCustomerExist()) {
      newClubSignup.customerId = customerId();
    }
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    newClubSignup.acquisitionChannel = 'Web';
    const response = yield call(createClubSignup, newClubSignup);
    Cookies.set('clubSignupId', response.data.id, {
      expires: 365,
      secure: process.env.APP_MODE === 'production'
    });
    yield put({ type: CLUB_SIGNUP_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'selectClub',
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } else {
    const response = yield call(update, {
      clubSignup: newClubSignup,
      onSuccess: action.onSuccess
    });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'selectClub',
      payload: response
    });
  }
}

function* update(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      updateClubSignup,
      clubSignupId(),
      action.clubSignup
    );

    yield put({ type: CLUB_SIGNUP_SUCCESS, payload: response.data });
    yield put({ type: GET_VIRTUAL_CART_REQUEST });

    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (action.onError) {
      action.onError();
    }
    yield call(addAPIError, error);
  }
  return null;
}

function* updateVirtualSignup(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      editVirtualSignUp,
      clubSignupId(),
      action.payload
    );
    yield put({ type: CLUB_SIGNUP_VIRTUAL_SUCCESS, payload: response.data });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    return response.data;
  } catch (error) {
    if (action.onError) {
      action.onError();
    }
    yield call(addAPIError, error);
  }
  return null;
}

function* processClubSignupSaga(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      processClubSignup,
      clubSignupId(),
      action.payload
    );
    yield put({ type: CLUB_SIGNUP_SUCCESS, payload: response.data });
    Cookies.remove('clubSignupId');
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubSignupComplete',
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

function* processPaystack(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      processPayStackClubSignup,
      clubSignupId(),
      action.payload
    );
    yield put({ type: CLUB_SIGNUP_SUCCESS, payload: response.data });

    Cookies.remove('clubSignupId');
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubSignupComplete',
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

function* createCustomerAndSetupIntentSaga(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      createCustomerAndSetupIntent,
      clubSignupId(),
      action.paymentMethodData
    );
    yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* processClubSignupFromPaymentRequestSaga(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_SIGNUP_OBJECT_REQUESTING });
    const response = yield call(
      processClubSignupFromPaymentRequest,
      clubSignupId(),
      action.clubSignupUpdateParams
    );
    yield put({ type: CLUB_SIGNUP_SUCCESS, payload: response.data });
    Cookies.remove('clubSignupId');
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubSignupComplete',
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_SIGNUP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* watchList() {
  yield takeLatest(CLUB_SIGNUP_REQUEST, get);

  yield takeLatest(
    UPDATE_DYNAMIC_PRICING_CLUB_SIGNUP_PACKAGE_REQUEST,
    updateDynamicClubSignupPricing
  );

  yield takeLatest(GET_CLUB_SIGNUP_FOR_SHARING_REQUEST, getForSharing);
  yield takeLatest(GET_VIRTUAL_CART_REQUEST, getVirtualCartSaga);

  yield takeLatest(EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST, updateVirtualSignup);

  yield takeLatest(UPDATE_CLUB_SIGNUP_REQUEST, update);

  yield takeLatest(PROCESS_CLUB_SIGN_UP_REQUEST, processClubSignupSaga);

  yield takeLatest(PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST, processPaystack);

  yield takeLatest(CREATE_CLUB_SIGNUP_REQUEST, create);
  yield takeLatest(CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST, createBySlug);
  yield takeLatest(
    CREATE_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST,
    createCustomerAndSetupIntentSaga
  );
  yield takeLatest(
    PROCESS_STRIPE_CLUB_SIGNUP_FROM_PAYMENT_REQUEST,
    processClubSignupFromPaymentRequestSaga
  );
  yield takeLatest(
    GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET,
    authenticateFullSteamWallet
  );
  yield takeLatest(
    PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST,
    processClubForDigitalWallet
  );
}

export default function* clubSignupSagas() {
  yield all([watchList()]);
}

const clubSignupId = () => Cookies.get('clubSignupId');
